"use client";

import Image from "next/image";
import { Heading } from "@/components/ui/typography";

const features = [
  {
    icon: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.667 2.5L4.167 11.667H10L8.333 17.5L15.833 8.333H10L11.667 2.5Z"
          stroke="#335CFF"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    title: "Simple requests handled quickly",
    description: "No manual tracking. No compliance guesswork.",
  },
  {
    icon: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="10" cy="10" r="7.5" stroke="#335CFF" strokeWidth="1.5" />
        <path
          d="M10 6.667V10L12.5 12.5"
          stroke="#335CFF"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    title: "Ongoing updates managed for you",
    description:
      "Your records stay current and accurate without the admin burden.",
  },
];

export default function CompanyChanges({ heading = "Built Around Your Company's Ongoing Changes" }: { heading?: string } = {}) {
  return (
    <section className="px-4 min-[1340px]:px-0 py-[30px]">
      <div className="flex flex-col lg:flex-row gap-10 lg:items-center max-w-[1200px] mx-auto">
        {/* LEFT SIDE */}
        <div className="flex-1 flex flex-col gap-6">
          <Heading as="h2" variant="section">
            {heading}
          </Heading>

          <div className="flex flex-col gap-4">
            <p className="font-inter text-white/70 text-[15px] lg:text-[18px] leading-[24px]">
              As your business grows, updates need to be documented correctly
              and submitted when required.
            </p>
            <p className="font-inter  text-white/70 text-[15px] lg:text-[18px] leading-[24px]">
              We coordinate required filings, maintain company registers, and
              keep your structure organised over time, so nothing falls behind.
            </p>
          </div>

          <div className="flex flex-col gap-4 mt-2">
            {features.map((feature, i) => (
              <div key={i} className="flex items-start gap-4">
                <div className="shrink-0 w-9 h-9 rounded-lg bg-[#0f1218] border border-white/10 flex items-center justify-center">
                  {feature.icon}
                </div>
                <div className="flex flex-col gap-0.5">
                  <p className="font-jakartra font-bold text-white text-[13px] lg:text-[14px] leading-[22.4px]">
                    {feature.title}
                  </p>
                  <p className="font-inter text-white/60 text-[12px] lg:text-[13px] leading-[22.1px]">
                    {feature.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="flex-1 max-sm:w-full relative max-sm:h-[calc(100vw-95px)] h-[502px]">
          <Image
            src="/corporate-secretary/faq.png"
            alt="Corporate Secretary"
            fill
            className="object-contain"
          />
        </div>
      </div>
    </section>
  );
}
